export function loadWafCaptcha() {
  if (document.getElementById("AwsWAFScript")) return;

  const AwsWafScript = document.createElement("script");
  AwsWafScript.id = "AwsWAFScript";
  AwsWafScript.async = false;
  AwsWafScript.src = process.env["REACT_APP_WAF_CAPTCHA_URL"];
  document.head.appendChild(AwsWafScript);
}
